<template>
  <pt-refund-order-list class="pt-refund-order-list__withData" @exportRefund="exportRefund" :exportLoading="exportLoading" ref="table" :pageSize="pageSize"></pt-refund-order-list>
</template>

<script>
import PtRefundOrderList from './index'
// import { dataExport } from 'utils/formUtils'
export default {
  name: 'pt-refund-order-list__withData',
  components: {
    'pt-refund-order-list': PtRefundOrderList
  },
  data () {
    return {
      exportLoading: false,
      pageSize: 30
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    exportRefund (val) {
      let data = {
        ...val,
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.exportLoading = true
      this.$store.dispatch('exportForRefundment', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message(err || '导出退款订单失败')
      })
    }
  }
}
</script>
